<drawer
  [title]="'Add Role'"
  [showHeaderButtons]="true"
  [hideDelete]="true"
  [hideCancel]="false"
  [hideSave]="false"
  [isClosed]="false"
  (saveEvent)="saveRole()"
  (cancelEvent)="cancel()"
  (closeEvent)="cancel()">
    <div class="drawer-content drawer-direct-content">
        <role-manage [role]="role" [determinantMapById]="determinantMapById" [institutions]="institutions"
                         [roleInstitutions]="[]"
                         [serviceId]="serviceId" [showRoleAdd]="showRoleAdd" (modalAddedEvent)="added()"></role-manage>
    </div>
</drawer>